function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-trappeVisite");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-trappeVisite",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,4 L21,8 L21,28.5 L4,24 L4,4 Z M26,4 L26,24 L22,24 L22,7 L5,4 L26,4 Z",
  id: "Combined-Shape-Copy"
})));

const SvgIco30TrappeVisite = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30TrappeVisite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-trappeVisite.56d02954.svg";
export { ForwardRef as ReactComponent };